import * as React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import './style.less';
import { NavLink } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
const lightHouseImage = require('../../../../images/Lighthouse.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
const invalidInvoiceImage = require('../../../../images/invalid-invoice.svg');

interface IGenericErrorProps {
    userAccessCheck?: () => boolean;
    onClick?: () => void;
    errorCode?: number;
    invalidInvoice?: boolean;
}
class GenericErrorComponent extends React.Component<IGenericErrorProps, {}> {
    public render() {
        const PAGE_ERROR_CONTENT = (this.props.errorCode === 404 || this.props.errorCode === 204) ?
            'We can\'t find the content you\'re looking for' : 'We can\'t find the page you\'re looking for';
        const ERROR_PERSISTS = 'If the error persists please';
        const SUBMIT_TEXT = this.props.userAccessCheck && this.props.userAccessCheck() ?
            'submit a bug' : 'let us know'
        const SUBMIT_BUG_LINK = '/app/support/error-report';
        const SUBMIT_FEEDBACK_LINK = '/app/support/feedback?app=Billing';
        const SUBMIT = this.props.userAccessCheck && this.props.userAccessCheck() ?
            [(
                <NavLink style={{ textDecoration: 'none', cursor : 'pointer'}}
                    to={SUBMIT_BUG_LINK} className="tc-billing-submit-feedback" key={0}>
                    {SUBMIT_TEXT}</NavLink>
            )] :
            [(
                <NavLink style={{ textDecoration: 'none', cursor : 'pointer' }}
                    to={SUBMIT_FEEDBACK_LINK} className="tc-billing-submit-feedback" key={1}>
                    {SUBMIT_TEXT}</NavLink>
            )]
        return (
            <div className="generic-error-container" id="genericContainer">
                <div className="generic-image-container row">
                    {this.props.invalidInvoice ? <img className="invalid-invoice-image" src={invalidInvoiceImage} /> :
                        <img className="generic-error-image" src={lightHouseImage} />}
                </div>
                <div className="generic-error-content row text-bold">
                    {PAGE_ERROR_CONTENT}
                </div>
                <div className="go-back-row">
                    <Button className={this.props.invalidInvoice ? 'invalid-invoice-go-back-btn' : 'go-back-btn'}
                        type="button" label="Go back"
                        variant="super" size="medium" onClick={this.props.onClick} />
                </div>
                <div className="error-footer-row">
                    {!this.props.invalidInvoice && <span className="error-persist-content text-light">
                        {ERROR_PERSISTS}&nbsp;{SUBMIT}</span>}
                </div>
            </div>
        )
    }

}

export { GenericErrorComponent }
